import {
    POST_ASSIGN_INSPECTOR, POST_ASSIGN_INSPECTOR_ERROR,
    POST_WAIVEOFF_INSPECTION, POST_WAIVEOFF_INSPECTION_ERROR,
    // POST_ACCEPT_REJECT_INSPECTION,
    POST_ACCEPT_REJECT_INSPECTION_ERROR,
    GET_INSPECTION_DETAILS_BY_INSPECTORID, GET_INSPECTION_DETAILS_BY_INSPECTORID_ERROR,
    GET_INSPECTION_DETAILS_BY_INSPECTORID_FOR_DASHBOARD, GET_INSPECTION_DETAILS_BY_INSPECTORID_FOR_DASHBOARD_ERROR,
    GET_ALL_INSPECTORS_WITH_TYPE, GET_ALL_INSPECTORS_WITH_TYPE_ERROR,
    GET_INSPECTOR_ALLOCATIONS_BY_INSPECTOR_ID, GET_INSPECTOR_ALLOCATIONS_BY_INSPECTOR_ID_ERROR,
    GET_INSPECTOR_ALLOCATIONS, GET_INSPECTOR_ALLOCATIONS_ERROR,
    GET_INSPECTION_DETAILS_BY_CALLID, GET_INSPECTION_DETAILS_BY_CALLID_ERROR,
    // PATCH_UPDATE_INSPECTION_STATUS,PATCH_UPDATE_INSPECTION_STATUS_ERROR,
    SUPPLIER_INSPECTION, SUPPLIER_INSPECTION_ERROR,
    CHANGE_SUPPLIER_DOCUMENT_STATUS, CHANGE_SUPPLIER_DOCUMENT_STATUS_ERROR,
    GET_CALL_LINEITEM_DETAILS_BY_CALLID, GET_CALL_LINEITEM_DETAILS_BY_CALLID_ERROR,
    GET_DOCUMENTS_UPLOADED_BY_INSPECTOR, GET_DOCUMENTS_UPLOADED_BY_INSPECTOR_ERROR, GET_ALL_CALLS,
    GET_NEW_INSPECTIONS_BY_INSPECTORID, GET_NEW_INSPECTIONS_BY_INSPECTORID_ERROR,
    GET_ALL_CALLS_ERROR,
    POST_REJECTHOLDINSPECTION, POST_REJECTHOLDINSPECTION_ERROR
} from '../type'
import axios from 'axios';
import env from '../../ENV';
import swal from '@sweetalert/with-react';
let ROOT_URL = env.BACKEND_URL;

export const getInspectionDetailsByInspectorID = (inspectorId, obj) => async dispatch => {

    var Id = inspectorId ? inspectorId : 0

    try {
        const res = await axios({
            method: 'post',
            url: `${ROOT_URL}inspector/${Id}/inspections`,
            data: obj,
            headers: {
                'content-type': 'application/json',
            }
        })
        dispatch({
            type: GET_INSPECTION_DETAILS_BY_INSPECTORID,
            payload: res.data,

        })
    }
    catch (e) {
        dispatch({
            type: GET_INSPECTION_DETAILS_BY_INSPECTORID_ERROR,
            payload: console.log(e),
        })
    }

}

export const getInspectionDetailsByInspectorIDForDashboard = (inspectorId, obj) => async dispatch => {

    var Id = inspectorId ? inspectorId : 0

    try {
        const res = await axios({
            method: 'post',
            url: `${ROOT_URL}inspector/${Id}/inspectionsdashboard`,
            data: obj,
            headers: {
                'content-type': 'application/json',
            }
        })
        dispatch({
            type: GET_INSPECTION_DETAILS_BY_INSPECTORID_FOR_DASHBOARD,
            payload: res.data,

        })
    }
    catch (e) {
        dispatch({
            type: GET_INSPECTION_DETAILS_BY_INSPECTORID_FOR_DASHBOARD_ERROR,
            payload: console.log(e),
        })
    }

}


export const getNewInspectionsByInspectorID = (inspectorId) => async dispatch => {

    var Id = inspectorId ? inspectorId : 0

    try {
        const res = await axios.get(`${ROOT_URL}new-inspections/${Id}/inspctor`)
        dispatch({
            type: GET_NEW_INSPECTIONS_BY_INSPECTORID,
            payload: res.data
        })
    }
    catch (e) {
        dispatch({
            type: GET_NEW_INSPECTIONS_BY_INSPECTORID_ERROR,
            payload: console.log(e),
        })
    }

}

export const postAssignInspector = (InspectionId = '', data) => async dispatch => {
    if (InspectionId) {
        try {
            const res = await axios({
                method: 'post',
                // url: `${ROOT_URL}inspection/${callId}`,
                url: `${ROOT_URL}inspection/updateInspection`,
                data: data,
                headers: {
                    'content-type': 'application/json',
                }
                // headers: {
                // 'Content-Type': 'multipart/form-data',
                // },
            })
            swal("Inspector Assigned Successfully", { icon: "success" })
            dispatch({
                type: POST_ASSIGN_INSPECTOR,
                payload: res.data
            })
        }
        catch (e) {
            let message = e && e.response && e.response.data && e.response.data.message ? e.response.data.message : "Something went wrong, please try again later"
            swal(message, { icon: "error" });
            dispatch({
                type: POST_ASSIGN_INSPECTOR_ERROR,
                payload: console.log(e),
            })
        }
    } else {
        try {
            const res = await axios({
                method: 'post',
                url: `${ROOT_URL}inspection/addInspection`,
                data: data,
                headers: {
                    'content-type': 'application/json',
                }
                // headers: {
                // 'Content-Type': 'multipart/form-data',
                // },
            })
            swal("Inspector Assigned Successfully", { icon: "success" })
            dispatch({
                type: POST_ASSIGN_INSPECTOR,
                payload: res.data
            })
        }
        catch (e) {
            let message = e && e.response && e.response.data && e.response.data.message ? e.response.data.message : "Something went wrong, please try again later"
            swal(message, { icon: "error" });
            dispatch({
                type: POST_ASSIGN_INSPECTOR_ERROR,
                payload: console.log(e),
            })
        }
    }

}

export const postWaiveOffInspection = (callId, data = {}) => async dispatch => {

    try {
        const res = await axios({
            method: 'patch',
            url: `${ROOT_URL}inspection/${callId}/waiveOff`,
            data: data,
            headers: {
                'content-type': 'application/json',
            }
            // headers: {
            // 'Content-Type': 'multipart/form-data',
            // },
        })
        dispatch({
            type: POST_WAIVEOFF_INSPECTION,
            payload: res.data
        })
    }
    catch (e) {
        dispatch({
            type: POST_WAIVEOFF_INSPECTION_ERROR,
            payload: console.log(e),
        })
    }

}

export const postAcceptRejectInspection = (id, callId, data) => async dispatch => {

    try {

        // const res = 
        await axios({
            method: 'patch',
            url: `${ROOT_URL}inspector/${id}/inspection/${callId}`,
            data: data,
            headers: {
                'content-type': 'application/json',
            }
            // headers: {
            // 'Content-Type': 'multipart/form-data',
            // },
        })
    }
    catch (e) {
        dispatch({
            type: POST_ACCEPT_REJECT_INSPECTION_ERROR,
            payload: console.log(e),
        })
    }

}

export const getAllInspectorswithTypes = () => async dispatch => {

    try {
        const res = await axios.get(`${ROOT_URL}inspectors`)
        dispatch({
            type: GET_ALL_INSPECTORS_WITH_TYPE,
            payload: res.data
        })
    }
    catch (e) {
        dispatch({
            type: GET_ALL_INSPECTORS_WITH_TYPE_ERROR,
            payload: console.log(e),
        })
    }

}

export const getInspectorAllocationsByInspectorId = (inspectorId, year, month) => async dispatch => {
    try {
        const res = await axios.get(`${ROOT_URL}inspector/${inspectorId}/allocations/${year}/${month}`)
        dispatch({
            type: GET_INSPECTOR_ALLOCATIONS_BY_INSPECTOR_ID,
            payload: res.data
        })
        // console.log(res.data)
    }
    catch (e) {
        dispatch({
            type: GET_INSPECTOR_ALLOCATIONS_BY_INSPECTOR_ID_ERROR,
            payload: console.log(e),
        })
    }
}

export const getInspectorAllocations = (year, month, data = {}) => async dispatch => {
    try {
        const res = await axios.post(`${ROOT_URL}inspector/allocations/${year}/${month}`, data)
        dispatch({
            type: GET_INSPECTOR_ALLOCATIONS,
            payload: res.data
        })
        // console.log(res.data)
    }
    catch (e) {
        dispatch({
            type: GET_INSPECTOR_ALLOCATIONS_ERROR,
            payload: console.log(e),
        })
    }
}
export const GetInspectorAllocationsByInspectorIdWithRange = (inspectorId, year, month, startDate, endDate) => async dispatch => {
    try {
        // const res = await axios.get(`${ROOT_URL}inspector/${inspectorId}/allocations/${year}/${month}`)
        const res = await axios.post(`${ROOT_URL}inspector/${inspectorId}/allocations/${year}/${month}`, {
            startDate: startDate,
            endDate: endDate
        })
        dispatch({
            type: GET_INSPECTOR_ALLOCATIONS_BY_INSPECTOR_ID,
            payload: res.data
        })
        // console.log(res.data)
    }
    catch (e) {
        dispatch({
            type: GET_INSPECTOR_ALLOCATIONS_BY_INSPECTOR_ID_ERROR,
            payload: console.log(e),
        })
    }
}

export const getInspectionDetailsByCallID = (callId) => async dispatch => {
    console.log(callId)
    try {
        const res = await axios.get(`${ROOT_URL}inspection-calls/${callId}`)
        dispatch({
            type: GET_INSPECTION_DETAILS_BY_CALLID,
            payload: res.data
        })
        // console.log(res.data)
    }
    catch (e) {
        dispatch({
            type: GET_INSPECTION_DETAILS_BY_CALLID_ERROR,
            payload: console.log(e),
        })
    }
}

export const getInspectionDetailsByInspectionId = (InspectionId) => async dispatch => {
    console.log(InspectionId)
    try {
        const res = await axios.get(`${ROOT_URL}inspection/getInspection/${InspectionId}`)
        dispatch({
            type: GET_INSPECTION_DETAILS_BY_CALLID,
            payload: res.data
        })
        // console.log(res.data)
    }
    catch (e) {
        dispatch({
            type: GET_INSPECTION_DETAILS_BY_CALLID_ERROR,
            payload: console.log(e),
        })
    }
}

export const getCallLineItemDetailsById = (callId, InspectionId) => async dispatch => {
    try {
        const res = await axios.get(`${ROOT_URL}inspection-callId/${callId}/${InspectionId}`)
        dispatch({
            type: GET_CALL_LINEITEM_DETAILS_BY_CALLID,
            payload: res.data
        })
        // console.log(res.data)
    }
    catch (e) {
        dispatch({
            type: GET_CALL_LINEITEM_DETAILS_BY_CALLID_ERROR,
            payload: console.log(e),
        })
    }
}

export const patchUpdateInspectionStatus = (callId, data) => async dispatch => {
    try {
        // const res = 
        await axios({
            method: 'patch',
            url: `${ROOT_URL}inspection/${callId}/status`,
            data: data,
            headers: {
                'content-type': 'application/json',
            }
        })

    }
    catch (e) {
        dispatch({
            type: GET_INSPECTION_DETAILS_BY_CALLID_ERROR,
            payload: console.log(e),
        })
    }
}

// Create A new call item for rework reoffer
export const createReworkReofferCallItem = (callItemId, data) => async dispatch => {
    try {
        // const res = 
        await axios({
            method: 'post',
            url: `${ROOT_URL}inspection/${callItemId}/rework`,
            data: data,
            headers: {
                'content-type': 'application/json',
            }
        })

    }
    catch (e) {
        dispatch({
            type: GET_INSPECTION_DETAILS_BY_CALLID_ERROR,
            payload: console.log(e),
        })
    }
}

export const getsupplierInspection = (userId) => async dispatch => {

    //var inspectorId = 1

    try {
        const res = await axios.get(`${ROOT_URL}vendor/user/${userId}/inspections`)
        // console.log(res.data,"data")
        dispatch({
            type: SUPPLIER_INSPECTION,
            payload: res.data

        })
    }
    catch (e) {
        dispatch({
            type: SUPPLIER_INSPECTION_ERROR,
            payload: console.log(e),
        })
    }

}

export const addcommentstoadvance = (poId, CurrentVersionId, DocumentId, data) => async dispatch => {

    try {

        const res = await axios({
            method: 'patch',
            url: `${ROOT_URL}inspection/${poId}/${CurrentVersionId}/${DocumentId}`,
            data: data,
            headers: {
                'content-type': 'application/json',
            }
        })
        dispatch({
            type: CHANGE_SUPPLIER_DOCUMENT_STATUS,
            payload: res.data
        })
    }
    catch (e) {
        dispatch({
            type: CHANGE_SUPPLIER_DOCUMENT_STATUS_ERROR,
            payload: console.log(e),
        })
    }

}

export const getAllDocumentsUploadedByInpsector = (id) => async dispatch => {
    try {
        const res = await axios.get(`${ROOT_URL}GetAllDocumentsUploadedByInpsector/${id}`)
        dispatch({
            type: GET_DOCUMENTS_UPLOADED_BY_INSPECTOR,
            payload: res.data
        })
    }
    catch (e) {
        dispatch({
            type: GET_DOCUMENTS_UPLOADED_BY_INSPECTOR_ERROR,
            payload: console.log(e),
        })
    }
}

export const uploadInspectionCSMTLink = (data, InspectionLineItemID) => async dispatch => {
    try {
        // const res = 
        await axios({
            method: 'patch',
            url: `${ROOT_URL}inspection/${InspectionLineItemID}/csmtlink`,
            data: data,
            headers: {
                'content-type': 'application/json',
            }
        })

    }
    catch (e) {
        dispatch({
            type: GET_INSPECTION_DETAILS_BY_CALLID_ERROR,
            payload: console.log(e),
        })
    }
}

export const getCallsWithCallLineItems = (data) => async dispatch => {
    try {
        const res = await axios.post(`${ROOT_URL}get-call`, data)
        dispatch({
            type: GET_ALL_CALLS,
            payload: res.data
        })
        // console.log(res.data)
    }
    catch (e) {
        dispatch({
            type: GET_ALL_CALLS_ERROR,
            payload: console.log(e),
        })
    }
}
export const rejectHoldInspection = (input) => async dispatch => {
    try {
        const res = await axios.post(`${ROOT_URL}inspection/rejectHoldInspection`, input)
        dispatch({
            type: POST_REJECTHOLDINSPECTION,
            payload: res.data
        })
    }
    catch (e) {
        dispatch({
            type: POST_REJECTHOLDINSPECTION_ERROR,
            payload: console.log(e),
        })
    }
}